import { useState, useEffect } from "react";
import Select from "react-select";
import "./ModulesAdmin.css";
import firebaseHelper from "../../../helpers/firebaseHelper";

function AddModuleModal({ onClose, onSave, isSaving, userRole }) {
  const [pageName, setPageName] = useState("");
  const [pageURL, setPageURL] = useState("");
  const [status, setStatus] = useState("active");
  const [icon, setIcon] = useState("");
  const [description, setDescription] = useState("");
  const [priority, setPriority] = useState(20);
  const [isVisibleForAll, setIsVisibleForAll] = useState(false);
  const [subsidiaries, setSubsidiaries] = useState([]);
  const [selectedSubsidiaries, setSelectedSubsidiaries] = useState([]);
  const [isUploading, setIsUploading] = useState(false);
  const [iconUploadError, setIconUploadError] = useState(null)

  useEffect(() => {
    const fetchSubsidiariesList = async () => {
      const subsidiariesList = await firebaseHelper.fetchSubsidiaries()
      setSubsidiaries(subsidiariesList)

    };
    fetchSubsidiariesList();
  }, []);

    // Função de upload de arquivo
    const handleIconUpload = async (file) => {
  
      try {
        setIsUploading(true);
        setIconUploadError(null);
        const fileURL = await firebaseHelper.uploadModuleIcon(file)
  
        setIcon(fileURL);
      } catch (error) {
        setIconUploadError(error.message)
        console.warn("[handleIconUpload] Erro no upload do icon: ", error);
      } finally {
        setIsUploading(false); 
      }
    };


  const handleSave = () => {
    const subsidiariesArray = selectedSubsidiaries.map((sub) => sub.value);
    // console.log('subsidiaries: ', subsidiariesArray);
    onSave({
      ...module,
      pageName,
      pageURL,
      isActive: status === "active",
      icon: icon,
      priority,
      description: description,
      isVisibleForAll: isVisibleForAll,
      subsidiaries: subsidiariesArray,
    });
  };

  const handleSubsidiaryChange = (selectedOptions) => {
    setSelectedSubsidiaries(selectedOptions);
  };

  return (
    <div className="modal">
      <div className="modal-content-modules">
        <h2>Add New Module</h2>
        <label>
          <p>Name:</p>
          <input
            className="input-modules"
            type="text"
            value={pageName}
            onChange={(e) => setPageName(e.target.value)}
          />
        </label>
        <label>
          <p>Description:</p>
          <input
            className="input-modules"
            type="text"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
          />
        </label>
        <label>
          <p>Link:</p>
          <input
            className="input-modules"
            type="text"
            value={pageURL}
            onChange={(e) => setPageURL(e.target.value)}
          />
        </label>
<label>
  <p>Icon:</p>
  <input
    className="input-modules"
    type="file"
    accept="image/*"
    onChange={(e) => handleIconUpload(e.target.files[0])}
    disabled={isUploading}
  />
</label>
{iconUploadError && (
  <p style={{
    color: 'red',
   fontSize: '0.9em',
    margin: '4px auto 8px auto',
    padding: '0',
    textAlign: "center"
  }}>
    {iconUploadError}
  </p>
)}
{isUploading && (
  <p style={{
    color: 'blue',
    fontSize: '0.9em',
    margin: '4px auto 8px auto',
    padding: '0',
    textAlign: "center"
  }}>
    Uploading...
  </p>
)}
        <label>
          <p>Order Priority:</p>
          <input
            className="input-modules"
            type="number"
            value={priority}
            min="1"
            max="20"
            onChange={(e) => setPriority(e.target.value)}
          />
        </label>
        <label>
          <p>Status:</p>
          <select
            className="status-dropdown"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </label>

        {userRole === "admin_global" && (
          <>
            <label>
              <p>Subsidiary:</p>
              <Select
                isMulti
                options={subsidiaries}
                value={selectedSubsidiaries}
                onChange={handleSubsidiaryChange}
                className="subsidiary-select-dropdown"
                placeholder="Choose subsidiaries..."
              />
            </label>

            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={isVisibleForAll}
                onChange={(e) => setIsVisibleForAll(e.target.checked)}
              />
              <span>Visible for all users</span>
            </label>
          </>
        )}
        <div className="modal-actions">
          <button onClick={onClose}>Cancel</button>
          <button onClick={handleSave} className="save-buttom-modules">
            Save
          </button>
        </div>

        {isSaving && (
          <div className="loading-overlay">
            <div className="spinner"></div>
            <p>Saving changes, please wait...</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default AddModuleModal;
